import {Form, useNavigate} from 'react-router-dom';
import {Backdrop, CircularProgress, Menu, TextField} from '@mui/material';
import T from 'i18n-react';
import {vinMaxLength} from 'lib/utils/vinUtils';
import InfoPopper from 'components/UI/Popper/InfoPopper';
import EngineDisplacementInput from 'components/UI/Input/EngineDisplacementInput';
import SelectYearInput from 'components/UI/Input/SelectYearInput';
import SearchInAllDatabases from 'components/UI/Input/SearchInAllDatabases';
import React, {useState} from 'react';
import Button from "@mui/material/Button";
import {findReportsByFormData} from "lib/find-vin-api";

const SearchBarDropdown = (props) => {
    const [providedVin] = useState(props.vin || '');
    const [newVin, setNewVin] = useState(providedVin);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const maxYear = new Date().getFullYear();
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [engineCC, setEngineCC] = useState();
    const [year, setYear] = useState();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
        if (event.target?.id === 'searchBarVinInput') {
            return;
        }

        setAnchorEl(null);
        if (!newVin) {
            setNewVin(typeof providedVin === 'string' ? providedVin.toUpperCase() : providedVin);
        }
    };

    const onSubmit = (event) => {
        setAnchorEl(null);
        setIsSubmitting(true);
        event.preventDefault();
        const formData = new FormData(event.target);
        findReportsByFormData(formData).then(data => {
            navigate('/reports', {
                state: {
                    vin: data.vin,
                    reportData: data.data,
                    engineCC: formData?.get('engineDisplacement'),
                    firstRegistrationDate: formData?.get('year'),
                }
            });
            setIsSubmitting(false);
        });
    };

    return (isSubmitting ? <Backdrop
            sx={{zIndex: 50000}}
            open={isSubmitting}
        >
            <CircularProgress color={'primary'} size={150}/>
        </Backdrop> :
        <Form action={'/reports'} onSubmit={onSubmit} id='headerForm' autoComplete={'off'}>
            <TextField autoComplete={'off'}
                       ref={props.menuRef}
                       className={`searchBar`}
                       onClick={(event) => {
                           handleClick(event);
                           props.setOpen(true);
                       }}
                       id={'searchBarVinInput'}
                       name={'vin'}
                       type={'text'}
                       onChange={(event) => setNewVin(event.target.value?.trim().toUpperCase())}
                       onBlur={() => {
                           if (!newVin) setNewVin(typeof providedVin === 'string' ? providedVin.toUpperCase() : providedVin);
                       }}
                       value={newVin}
                       inputProps={{maxLength: vinMaxLength}}
            />
            <Menu
                id='searchHeaderDropdown'
                anchorEl={anchorEl}
                open={open}
                onClose={event => handleClose(event)}
                elevation={1}
                disableAutoFocus={true}
            >
                <div
                    className={`collapsible ${props.open ? 'active' : 'inactive'} ${props.isDatabasesSwitchChecked ? 'checked' : 'notChecked'}`}
                    ref={props.menuRef}
                >
                    <div className={'control'}>
                        <div className={'control-labels'}>
                            <label>{T.translate('carDataComponent.engineCC')}</label>
                            <InfoPopper size={'small'}
                                        message={T.translate('vinQueryComponent.engineCCTitle')}/>
                        </div>
                        <EngineDisplacementInput form={'headerForm'} setEngineCC={setEngineCC}/>
                    </div>
                    <div className={'control'}>
                        <div className={'control-labels'}>
                            <label>{T.translate('carDataComponent.registrationYear')}</label>
                            <InfoPopper size={'small'}
                                        message={T.translate('vinQueryComponent.registrationYearTitle')}/>
                        </div>
                        <SelectYearInput setYear={setYear} minYear={1990} form={'headerForm'}
                                         maxYear={maxYear}/>
                    </div>
                    <div className={'control'}>
                        <div className={'dropdown-subscriptions'}>
                            <SearchInAllDatabases onSelectDatabasesManually={props.setSelectedDatabases}
                                                  submitting={props.navigation?.state === 'submitting'}
                                                  vinFieldValue={newVin}
                                                  vinMaxLength={vinMaxLength}
                                                  isDatabasesSwitchChecked={props.isDatabasesSwitchChecked}
                                                  setIsDatabasesSwitchChecked={props.setIsDatabasesSwitchChecked}
                                                  year={year}
                                                  engineCC={engineCC}
                                                  error={props.error}
                                                  loading={props.loading}
                                                  form={'headerForm'}
                            />
                        </div>
                    </div>
                    <div className={'control'}>
                        <Button
                            className={`getReportButton ${props.isDatabasesSwitchChecked ? 'inactive' : 'active'}`}
                            disabled={isSubmitting || props.navigation?.state === 'submitting' || props.vinFieldValue?.length < vinMaxLength}
                            variant={'contained'}
                            type={'submit'}
                            form={'headerForm'}
                        >{T.translate("vinQueryComponent.getReport")}</Button>
                    </div>
                </div>
            </Menu>
        </Form>);

};

export default SearchBarDropdown;
